<template>
  <div class="user-card">
   
    <img :src="user.image" alt="User Image" class="user-image" />
    <div v-if="user.isComplete"  class="status-dot"></div>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: this.modelValue,
    };
  },
  watch: {
    modelValue(newValue) {
      this.checked = newValue;
    },
  },
};
</script>

<style scoped>
.user-card {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  overflow: hidden;
  cursor: pointer;
  position: relative; 
}

.user-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.status-dot {
  position: absolute;
  bottom: 35px;
  right: 8px;
  width: 12px;
  height: 12px;
  background-color: rgb(4, 176, 4);
  border-radius: 50%;
}
</style>
